// Which pages hide the sidebar nav. Shared by the layouts (to collapse the
// rail / swap the hamburger for a back arrow) and by DismissRoutes (to play
// the modal dismiss animation when one of these pages is closed).

// Admin tabs hidden from the top-bar segment (reached from the sidebar or
// settings): their pages take the full width with the sidebar collapsed.
export const ADMIN_TOPBAR_EXCLUDE = new Set([
  "saved-docs", "email-templates", "templates", "tax-layouts", "analytics", "health",
  "site-settings", "banned-ips", "export",
  "moderators", "mass-email", "broadcast", "audit-log", "support",
  "settings", "subscriptions", "preferences", "user-detail",
]);

export function adminActiveTab(path) {
  if (/^\/admin\/users\/[^/?#]+/.test(path))   return "user-detail"; // a user's own page
  if (path.includes("/admin/users"))           return "users";
  if (path.includes("/admin/purchases"))       return "purchases";
  if (path.includes("/admin/saved-docs"))      return "saved-docs";
  if (path.includes("/admin/discounts"))       return "discounts";
  if (path.includes("/admin/banned-ips"))      return "banned-ips";
  if (path.includes("/admin/email-templates")) return "email-templates";
  if (path.includes("/admin/tax-layouts"))     return "tax-layouts";
  if (path.includes("/admin/templates"))       return "templates";
  if (path.includes("/admin/broadcast"))       return "broadcast";
  if (path.includes("/admin/mass-email"))      return "mass-email";
  if (path.includes("/admin/blog"))            return "blog";
  if (path.includes("/admin/site-settings"))   return "site-settings";
  if (path.includes("/admin/moderators"))      return "moderators";
  if (path.includes("/admin/audit-log"))       return "audit-log";
  if (path.includes("/admin/support"))         return "support";
  if (path.includes("/admin/export"))          return "export";
  if (path.includes("/admin/revenue"))         return "revenue";
  if (path.includes("/admin/subscriptions"))   return "subscriptions";
  if (path.includes("/admin/preferences"))     return "preferences";
  if (path.includes("/admin/settings"))        return "settings";
  if (path.includes("/admin/analytics"))       return "analytics";
  if (path.includes("/admin/health"))          return "health";
  if (path.includes("/admin/calendar"))        return "calendar";
  return "calendar";
}

// /app pages that replace the hamburger with a back arrow and hide the rail.
export const APP_SECONDARY_PATHS = ["/app/terms", "/app/privacy", "/app/settings", "/app/my-documents", "/app/billing", "/app/referrals", "/app/account", "/app/preferences", "/app/business", "/app/employees", "/app/signatures", "/app/templates"];

export function pageHidesSidebar(pathname) {
  if (APP_SECONDARY_PATHS.includes(pathname)) return true;
  if (pathname.startsWith("/admin/") && pathname !== "/login") {
    return ADMIN_TOPBAR_EXCLUDE.has(adminActiveTab(pathname));
  }
  return false;
}
